import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import { useLocation } from "react-router-dom";
import { FaExchangeAlt } from "react-icons/fa";

import AssetOutwardChild from "./AssetOutwardChild";

const AssetOutward = () => {
  const { state } = useLocation();
  const selected_asset = state;

  return (
    <MainTemplate>
      <div className="p-4 w-full">
        <div className="flex flex-col gap-4 justify-between items-start mb-6 sm:flex-row sm:items-center">
          <div className="flex gap-3 items-center">
            <div className="p-2 bg-orange-100 rounded-md">
              <FaExchangeAlt className="text-orange-600" size={20} />
            </div>
            <h1 className="text-2xl font-bold text-gray-800">Asset Outward</h1>
          </div>
          
          {selected_asset && (
            <div className="px-3 py-1 text-sm font-medium text-blue-800 bg-blue-50 rounded-full">
              {selected_asset.asset_name}
            </div>
          )}
        </div>
        
        <CardBackground>
          <AssetOutwardChild issued={selected_asset} />
        </CardBackground>
      </div>
    </MainTemplate>
  );
};

export default AssetOutward;
